module.exports = __webpack_public_path__ + "img/workContents03-03.9153e08a.gif";